import { colorType } from '../color/type'
import { sizeType } from '../size/type'
import { formatSizeToDisplay } from '../size/util'
import { singleItemResponseType, slimItemType } from './server'

export const getDiscountedPriceFromDiscountRate = (
  price: number,
  discount_rate: number,
): number => {
  const newPrice = Math.floor(price * (1 - discount_rate / 100))

  // 一の位が0を四捨五入する
  if (newPrice % 10 === 0) {
    return newPrice
  } else if (newPrice % 10 < 5) {
    return newPrice - (newPrice % 10)
  } else {
    return newPrice + (10 - (newPrice % 10))
  }
}

// 割引率を取得する
export const getDiscountRate = ({
  singleItem,
}: {
  singleItem: singleItemResponseType
}) => {
  return singleItem.item.discount_rate > 0
    ? singleItem.item.discount_rate
    : singleItem.item.discounted_price > 0
      ? Math.round(
          ((singleItem.item.price - singleItem.item.discounted_price) /
            singleItem.item.price) *
            100,
        )
      : 0
}

export const getDiscountedPrice = (item: slimItemType) => {
  if (item.item_custom_options.filter((option) => option.discounted_price > 0).length > 0) {
    const discountedPrices = item.item_custom_options
      .filter((option) => option.discounted_price > 0)
      .map((option) => option.discounted_price)
    return Math.min(...discountedPrices)
  }
  if (item.discount_rate > 0) {
    return getDiscountedPriceFromDiscountRate(item.price, item.discount_rate)
  } else if (item.discounted_price > 0 && item.discounted_price < item.price) {
    return item.discounted_price
  }
  return 0
}

// カラーとサイズをフォーマット
export const formatColorAndSize = ({
  color,
  size,
}: {
  color?: colorType
  size?: sizeType
}) => {
  const textsColorAndSize = [
    color && color.name,
    color && size && '/',
    size && formatSizeToDisplay(size),
  ]

  return textsColorAndSize.filter((text) => text).join(' ')
}
